import { Layout } from '../components/layout/Layout';
import { Card, CardContent } from '../components/ui/card';
import { ChevronDown } from 'lucide-react';
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How long does the process take?",
      answer: "Results vary, typically 3-6 months depending on the complexity of your credit profile. Basic Restoration takes up to 3 months, while Premium Restoration may take up to 6 months for comprehensive service."
    },
    {
      question: "Is credit monitoring required?",
      answer: "Yes, $29/month credit monitoring is mandatory for all clients. This allows us to track your progress and identify items that need to be disputed on your credit report."
    },
    {
      question: "Can you guarantee results?",
      answer: "We cannot guarantee specific outcomes as results depend on individual credit profiles. However, we have a 95% success rate and offer a Money Back Guarantee if no results are achieved within 90 days."
    },
    {
      question: "Will my credit score go down?",
      answer: "In some cases, removing old accounts may temporarily affect your score. We recommend adding a credit builder account to your profile to help strengthen your score over time."
    },
    {
      question: "How can I increase my score?",
      answer: "We recommend credit builder services such as Self Lender, Kovo, Kikoff, and Credit Strong. These services help build your credit without adding hard inquiries to your report."
    },
    {
      question: "Can I report my rent to my credit?",
      answer: "Yes, reporting rent payments can help build your credit history. We recommend services such as Rent Reporters, Rental Kharma, and Boom Pay to report your on-time rent payments to the credit bureaus."
    },
    {
      question: "What documents do I need to provide?",
      answer: "You will need to provide a valid government-issued ID, proof of residence (utility bill or bank statement), and your Social Security Number for identity verification purposes."
    },
    {
      question: "How often will I receive updates?",
      answer: "We provide progress updates every 35 days. You'll receive detailed reports on what items have been disputed, removed, or are still pending with the credit bureaus."
    },
    {
      question: "What is the difference between Basic and Premium packages?",
      answer: "Basic Restoration ($297) covers collection disputes and personal information corrections over up to 3 months. Premium Restoration ($497) includes everything in Basic plus charge-offs, late payments, repossessions, bankruptcies, and public records over up to 6 months."
    },
    {
      question: "Can I cancel my service?",
      answer: "Yes, you may cancel at any time. However, please note that the initial service fee is non-refundable once work has begun on your file. The monthly monitoring fee can be cancelled at any time."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <Layout>
      {/* Hero Section */}
      <section className="bg-gradient-to-b from-slate-900 to-slate-800 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-white mb-4">
            Frequently Asked Questions
          </h1>
          <p className="text-slate-300 text-lg max-w-2xl mx-auto">
            Find answers to common questions about our Credit Restoration services.
          </p>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <Card 
                key={index} 
                className={`border-slate-200 cursor-pointer transition-all duration-200 ${
                  openIndex === index ? 'shadow-lg border-amber-300' : 'hover:border-slate-300'
                }`}
                onClick={() => toggleFAQ(index)}
                data-testid={`faq-item-${index}`}
              >
                <CardContent className="p-0">
                  <div className="flex items-center justify-between p-5">
                    <h3 className="font-semibold text-slate-900 pr-4">
                      {faq.question}
                    </h3>
                    <ChevronDown 
                      className={`h-5 w-5 text-slate-500 flex-shrink-0 transition-transform duration-200 ${
                        openIndex === index ? 'rotate-180' : ''
                      }`} 
                    />
                  </div>
                  {openIndex === index && (
                    <div className="px-5 pb-5 pt-0">
                      <p className="text-slate-600 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Still Have Questions */}
          <div className="mt-16 text-center p-8 bg-slate-50 rounded-2xl">
            <h2 className="font-heading text-2xl font-bold text-slate-900 mb-3">
              Still Have Questions?
            </h2>
            <p className="text-slate-600 mb-6">
              Our team is here to help. Reach out to us for personalized assistance.
            </p>
            <a 
              href="/contact" 
              className="inline-flex items-center justify-center px-6 py-3 bg-amber-600 hover:bg-amber-700 text-white font-medium rounded-lg transition-colors"
            >
              Contact Us
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
